/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { useState, useCallback, useRef, Suspense, useEffect } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { CustomDatePickerDialog } from "../../../../../shared";
import { CustomPagination } from "../../../../../shared";
import getAgGridHeight from "../../../../../../utils/commonFunctions/getAgGridHeight";
import PopOver from "../../../../../shared/popOvers/PopOver";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import BrushIcon from "@material-ui/icons/Brush";
import { GoogleGenerativeAI } from "@google/generative-ai";

import {
	Tooltip,
	IconButton,
	FormControl,
	FormGroup,
	FormControlLabel,
	Switch,
	FormHelperText,
	withStyles
} from "@material-ui/core";
import * as XLSX from "xlsx";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { handlePlanEndDateCellRenderer } from "../../../../../../utils/commonFunctions/cellRenderers";
import { api } from "../../../../../../utils/api";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { dateTimeZoneConverter } from "../../../../../../utils/commonFunctions/date";
import { trackPromise } from "react-promise-tracker";
import { FullScreenCustomPlanViewDialog } from "../../../../../shared";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography
} from "@mui/material";
import { AddBox } from "@material-ui/icons";
import PlanDesignFormDialog from "./addPlanDesign/AddPlanDialog";
import PlanDesignFormCellRenderer from "./PlanDesignFormCellRenderer";
import { useNavigate } from "react-router-dom";
import { PLANS } from "../../../../../../constants/plan";
import UpdateVEBPlan from "../../createPlan/veb/UpdateVEBPlan";
// import { BrandingPageForm } from "../../createPlan/veb/BrandingPageFrom";
import EditableBrandingPage from "../../createPlan/veb/EditableBrandingPage";
import DynamicBrandingPageCreation from "../../createPlan/veb/DynamicBrandingPageCreation/DynamicBrandingPageCreation";

const PurpleSwitch = withStyles({
	switchBase: {
		color: "#474747",
		"&$checked": {
			color: "#359a4c"
		},
		"&$checked + $track": {
			backgroundColor: "rgba(40, 167, 69, 0.8)"
		}
	},
	checked: {},
	track: {}
})(Switch);

const PlanManagementGrid = ({ gridProps, tabLabel, getPlans, coreVEBSwitchStatus }) => {
	// console.log("tabLabel", tabLabel);
	const [selectedRowData, setSelectedRowData] = useState([]);
	// const [selectedPlan, setSelectedPlan] = useState({});
	const [gridHeight, setGridHeight] = useState("400px");
	const queryGroupNumber = useRouteParam("gn");
	const [editEndDate, setEditEndDate] = useState("");
	const [isRowSelected, setIsRowSelected] = useState(false);
	const [agGridAPI, setAgGridAPI] = useState(null);
	const [anchorEl, setAnchorEl] = useState(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState(null);
	const [showPremiumComponent, setShowPremiumComponent] = useState(false);
	const [selectedPlan, setSelectedPlan] = useState(null);
	const [editModalType, setEditModalType] = useState(null);

	const [planDetailsPopOverData, setPlanDetailsPopOverData] = useState({
		plan_code: "",
		start_date: "",
		end_date: "",
		buy_up_eligibility: "Yes",
		employee_class: ""
	});
	const [open, SetOpen] = useState(false);
	const [customDatePickerDialogProps, setCustomDatePickerDialogProps] = useState();
	const [customFullScreenPlanViewDialogProps, setCustomFullScreenPlanViewDialogProps] = useState(false);
	const [planDetailsDialog, setPlanDetailsDialog] = useState();
	const agGridRef = useRef(null);
	const [pagination, setPagination] = useState({
		currentPage: 1,
		pageCount: 2
	});
	const { currentPage, pageCount } = pagination;

	const handleAgGridReady = (params) => {
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
	};

	const [openPlanDesignForm, setOpenPlanDesignForm] = useState(false);

	const handleOpenAddPlanDialog = () => setOpenPlanDesignForm(true);
	const handleClosePlanDesignForm = () => setOpenPlanDesignForm(false);

	// const handlePlanDesignFormSubmit = (data) => {
	// 	console.log("New plan created:", data);
	// 	// TODO: call your backend API to save it
	// };

	const handleOpenPopOverClick = useCallback((event) => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const { data } = row;
		setPlanDetailsPopOverData(
			Object.assign(
				{},
				{
					plan_name: data.plan_name,
					plan_code: data.plan_code,
					start_date: dateTimeZoneConverter(data.start_date),
					end_date: data.end_date ? dateTimeZoneConverter(data.end_date) : "Current",
					buy_up_eligibility: data.buy_up_eligibility ? data.buy_up_eligibility : "N/A",
					employee_class: data.employee_class ? data.employee_class : "N/A"
				}
			)
		);
		setAnchorEl(event.currentTarget);
	}, []);

	const handlePlanActiveInactiveHandleClick = useCallback(
		async (event, queryGroupNumber, coreVEBSwitchStatus) => {
			// const _value = event.target.checked;
			const _value = event;
			const focusedCell = agGridRef.current.api.getFocusedCell();
			const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
			const { data } = row;
			const { _id, plan_name } = data;

			// //console.log("queryGroupNumber", queryGroupNumber);
			// console.log("plan_name", plan_name, _value);

			const togglePlanStatusPayload = {
				_id,
				plan_name,
				group_number: queryGroupNumber,
				// plan_status: _value === false ? "INACTIVE" : "ACTIVE"
				status: _value === false ? "INACTIVE" : "ACTIVE"
			};
			// console.log("this is the satus toggle ", togglePlanStatusPayload);

			const response = await trackPromise(api.plan.togglePlanStatus(togglePlanStatusPayload));
			// console.log("group number", response);

			if (response) {
				alert("Plan Status Updated Successfully!");
				getPlans(coreVEBSwitchStatus);
			}
			SetOpen(false);
		},
		[getPlans]
	);

	const handleEditPlanEndDate = useCallback(async (queryGroupNumber, _id, endDate) => {
		// console.log("informsation", queryGroupNumber, _id, endDate);
		if (queryGroupNumber === null || queryGroupNumber === undefined) {
			return;
		}
		const terminatePlanPayload = {
			end_date: endDate,
			group_number: queryGroupNumber,
			_id: _id
		};
		// console.log("terminatePlan", terminatePlanPayload);
		const plan = await trackPromise(api.plan.terminatePlan(terminatePlanPayload));
		if (plan) {
			alert("Succesfully edited Plan End Date");
			window.location.reload();
		}
	}, []);
	const handlePremiumApi = async (queryGroupNumber, editEndDate) => {
		handleEditPlanDateClick(queryGroupNumber, editEndDate);
	};

	const handleEditPlanDateClick = useCallback(
		(queryGroupNumber, _editEndDate) => {
			const focusedCell = agGridRef.current.api.getFocusedCell();
			const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
			const { data } = row;

			if (coreVEBSwitchStatus && data?.premium_Amount === null) {
				handlePremiumApi();
			} else {
				setEditEndDate(data.end_date);

				setCustomDatePickerDialogProps(() =>
					Object.assign(
						{},
						{
							openDialog: true,
							title: "Edit Plan",
							_id: -1,
							textFields: [
								{
									label: "End Date",
									placeHolder: "Enter End Date",
									name: "end_date",
									value: data.end_date
								}
							],
							actions: [
								{
									label: "Cancel",
									name: "cancel",
									callback: () => {
										setCustomDatePickerDialogProps((prev) =>
											Object.assign({}, prev, { openDialog: false })
										);
									}
								},
								{
									label: "Submit",
									name: "Submit",
									callback: (endDate) => {
										setCustomDatePickerDialogProps((prev) =>
											Object.assign({}, prev, { openDialog: false })
										);
										handleEditPlanEndDate(queryGroupNumber, data._id, endDate);
									}
								}
							]
						}
					)
				);
			}
		},
		[handleEditPlanEndDate, handlePremiumApi, coreVEBSwitchStatus]
	);

	const handleClosePlanViewerCustomDialog = () => {
		setCustomFullScreenPlanViewDialogProps(false);
	};

	const handleOpenPlanViewerCustomDialog = useCallback(() => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const { data } = row;
		console.log("handleOpenPlanViewerCustomDialog", coreVEBSwitchStatus);
		console.log("planDetailsPopOverData", data);
		setPlanDetailsDialog(data);
		setCustomFullScreenPlanViewDialogProps(true);
	}, []);

	const handleCloseDialogClick = useCallback(() => {
		setCustomDatePickerDialogProps(Object.assign({}, customDatePickerDialogProps, { openDialog: false }));
	}, [customDatePickerDialogProps]);

	const handleFirstDataRendered = (params) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};
	const handleActionButtonRender = useCallback(
		({ anchorEl, planDetailsPopOverData, queryGroupNumber, editEndDate }) => {
			// console.log("editEndate cell", editEndDate);
			// console.log(tabLabel);
			return (
				<>
					{/* 👁 View Button */}
					<Tooltip title="View" enterDelay={200} leaveDelay={200} arrow>
						<IconButton onClick={handleOpenPlanViewerCustomDialog}>
							<VisibilityIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Edit" enterDelay={200} leaveDelay={200} arrow>
						<IconButton
							onClick={() => {
								handleEditPlanDateClick(queryGroupNumber, editEndDate);
							}}
						>
							<EditIcon />
						</IconButton>
					</Tooltip>

					<PopOver
						popOverTitle={"Plan Details"}
						anchorEl={anchorEl}
						popOverContent={planDetailsPopOverData}
						setAnchorEl={setAnchorEl}
						type={"grid"}
					/>
					{/* {tabLabel === "history" ? null : ( */}
					{/* {tabLabel === "Inactive Plans" ? null : (
						<>
							<Tooltip title="Edit" enterDelay={200} leaveDelay={200} arrow>
								<IconButton onClick={() => handleEditPlanDateClick(queryGroupNumber, editEndDate)}>
									<EditIcon />
								</IconButton>
							</Tooltip>
						</>
					)} */}
				</>
			);
		},
		[handleEditPlanDateClick, handleOpenPlanViewerCustomDialog, tabLabel]
	);

	const handleFormActionButtonRender = useCallback(
		({ data, anchorEl, setAnchorEl }) => {
			// data contains the full plan details for this row
			const { group_number, end_date, plan_name } = data;

			return (
				<>
					{/* View Form */}
					<Tooltip title="View Form Design" enterDelay={200} leaveDelay={200} arrow>
						<IconButton onClick={() => handleOpenPlanViewerCustomDialog(data)}>
							<VisibilityIcon />
						</IconButton>
					</Tooltip>

					<PopOver
						popOverTitle="Form Details"
						anchorEl={anchorEl}
						popOverContent={data} // can pass full plan data
						setAnchorEl={setAnchorEl}
						type="grid"
					/>

					{/* Edit Form */}
					<Tooltip title="Edit Form" enterDelay={200} leaveDelay={200} arrow>
						<IconButton onClick={() => handleEditPlanDateClick(group_number, end_date, data)}>
							<EditIcon />
						</IconButton>
					</Tooltip>

					{/* Add Form */}
					<Tooltip title="Add Form" enterDelay={200} leaveDelay={200} arrow>
						<IconButton onClick={() => handleOpenAddPlanDialog(data)}>
							<AddBox />
						</IconButton>
					</Tooltip>
				</>
			);
		},
		[handleOpenAddPlanDialog, handleEditPlanDateClick, handleOpenPlanViewerCustomDialog]
	);

	const handlePlanActiveHandleRender = useCallback(
		({ value, queryGroupNumber, coreVEBSwitchStatus }) => {
			const toggleSwitchStatusValue = value === "ACTIVE" ? true : value === "INACTIVE" ? false : null;
			// console.log(tabLabel,"value => ", value);
			// console.log("toggleSwitchStatusValue==>", toggleSwitchStatusValue);

			return (
				<FormControl component="fieldset">
					<FormGroup>
						{tabLabel == "Inactive Plans" ? (
							<>Inactive</>
						) : (
							<FormControlLabel
								control={
									<PurpleSwitch
										checked={toggleSwitchStatusValue}
										onChange={(event) => handlePlansDialogsOpen()}
									/>
								}
								label={value === "ACTIVE" ? "Active " : value === "INACTIVE" ? "Inactive" : ""}
							/>
						)}
					</FormGroup>
				</FormControl>
			);
		},
		[handlePlanActiveInactiveHandleClick, tabLabel]
	);

	const handlePlansDialogsOpen = () => {
		SetOpen(true);
	};
	const handlePlansDialoagClose = () => {
		SetOpen(false);
	};

	const handleSelectionChanged = useCallback(() => {
		const selectedRow = agGridAPI?.getSelectedRows();
		setSelectedRowData(Object.assign([], selectedRow));
		// //console.log("selected row", selectedRow);
		if (selectedRow) {
			setIsRowSelected(true);
		} else {
			setIsRowSelected(false);
		}
	}, [agGridAPI]);

	const handleEmployeeClassCellRenderer = ({ value }) => {
		return <div>{value ? value : "N/A"}</div>;
	};

	useEffect(() => {
		const _gridHeight = getAgGridHeight(gridProps.length);
		setGridHeight(_gridHeight);
	}, [gridProps.length]);
	const handleEditClick = (plan) => {
		setSelectedPlan(plan);

		if (coreVEBSwitchStatus && plan?.premium_Amount == null) {
			setEditModalType("VEB"); // open UpdateVEBPlan
		} else {
			setEditModalType("DATE"); // open CustomDatePickerDialog
		}
	};
	//  Branding Page handler
	const handleOpenBrandingPage = (plan) => {
		setSelectedPlan(plan); // store the selected plan

		// Open Branding Page modal
		setEditModalType("BRANDING"); // we will handle this in render
	};
	// console.log(tabLabel);

	const handleEditButtonRender = useCallback(
		({ tabLabel, queryGroupNumber, editEndDate, data }) => {
			const isPremiumTab = tabLabel === "Draft Plans"; // FIXED
			const showPremiumIcon = isPremiumTab && coreVEBSwitchStatus && data?.premium_amount == null; // ensure correct key name

			// console.log("showPremiumIcon:", showPremiumIcon, coreVEBSwitchStatus, data?.premium_amount);

			return (
				<>
					{showPremiumIcon ? (
						<Tooltip title="Edit Full VEB Plan" enterDelay={200} leaveDelay={200} arrow>
							<IconButton onClick={() => handleEditClick(data)}>
								<EditIcon />
							</IconButton>
						</Tooltip>
					) : (
						<Tooltip title="Edit" enterDelay={200} leaveDelay={200} arrow>
							<IconButton onClick={() => handleEditPlanDateClick(queryGroupNumber, editEndDate)}>
								<EditIcon />
							</IconButton>
						</Tooltip>
					)}
				</>
			);
		},
		[coreVEBSwitchStatus, handleOpenBrandingPage, handleEditClick, handleEditPlanDateClick]
	);

	useEffect(() => {
		if (selectedPlan?._id && showPremiumComponent?.pending) {
			// Open modal after selectedPlan is updated
			setShowPremiumComponent({ open: true, pending: false });
		}
	}, [selectedPlan, showPremiumComponent]);

	return (
		<>
			<Suspense fallback={<div />}>
				{customDatePickerDialogProps ? (
					<CustomDatePickerDialog
						dialogProps={customDatePickerDialogProps}
						setDialogProps={setCustomDatePickerDialogProps}
						handleClose={handleCloseDialogClick}
						editEndDate={editEndDate}
						setEditEndDate={setEditEndDate}
					/>
				) : null}
			</Suspense>
			<Suspense fallback={<div />}>
				{customFullScreenPlanViewDialogProps ? (
					<FullScreenCustomPlanViewDialog
						planDetails={planDetailsDialog}
						planDialogOpenStatus={customFullScreenPlanViewDialogProps}
						handleClickOpen={handleOpenPlanViewerCustomDialog}
						handleClose={handleClosePlanViewerCustomDialog}
						planType={coreVEBSwitchStatus}
					/>
				) : null}
			</Suspense>

			{/* <Suspense fallback={<div />}>
				{openPlanDesignForm ? (
					<PlanDesignFormDialog
						open={openPlanDesignForm}
						onClose={handleClosePlanDesignForm}
						onSubmit={handlePlanDesignFormSubmit}
					/>
				) : null}
			</Suspense> */}

			<Dialog open={open} onClose={handlePlansDialoagClose}>
				<DialogTitle>
					<Typography variant="h6" fontWeight="bold" color="error">
						⚠ Warning: Plan Deactivation Will Terminate Employee Benefits
					</Typography>
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<Typography variant="body1">
							You are about to <strong>deactivate this plan</strong>. Once deactivated, all employee
							benefits associated with this plan will be <strong>terminated immediately</strong> and{" "}
							<strong>cannot be recovered</strong>.
						</Typography>
						<Typography variant="body1" sx={{ mt: 1 }}>
							Are you sure you want to proceed?
						</Typography>
					</DialogContentText>
				</DialogContent>
				<DialogActions sx={{ padding: "16px" }}>
					{/* Cancel Button */}
					<Button
						onClick={handlePlansDialoagClose}
						variant="outlined"
						color="secondary"
						sx={{
							borderRadius: 2,
							px: 3,
							fontWeight: "bold",
							borderWidth: 2,
							"&:hover": {
								backgroundColor: "rgba(0, 0, 0, 0.04)",
								borderColor: "secondary.dark",
								borderWidth: 2
							}
						}}
					>
						CANCEL
					</Button>

					{/* OK Button (Primary Action) */}
					<Button
						onClick={() =>
							handlePlanActiveInactiveHandleClick(false, queryGroupNumber, coreVEBSwitchStatus)
						}
						variant="contained"
						color="error"
						sx={{
							borderRadius: 2,
							px: 3,
							fontWeight: "bold",
							backgroundColor: "#d32f2f",
							"&:hover": { backgroundColor: "#b71c1c" }
						}}
					>
						CONFIRM
					</Button>
				</DialogActions>
			</Dialog>

			<div className="plan-management-grid-conatiner grid-margin">
				<div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
					{queryGroupNumber ? (
						<AgGridReact
							ref={agGridRef}
							key={tabLabel}
							rowData={gridProps}
							onGridReady={handleAgGridReady}
							onFirstDataRendered={handleFirstDataRendered}
							rowSelection={"multiple"}
							onSelectionChanged={handleSelectionChanged}
							animateRows
							suppressColumnVirtualisation={true}
							defaultColDef={{
								filter: "agTextColumnFilter",
								floatingFilter: true,
								resizable: true,
								floatingFilterComponentParams: { suppressFilterButton: true }
							}}
							// onRowClicked={handleRowClicked}
							onCellValueChanged={(params) => {
								params.api.refreshCells({
									force: true,
									columns: ["action"]
								});
							}}
							enableCellChangeFlash={true}
							frameworkComponents={{
								handleEmployeeClassCellRenderer: handleEmployeeClassCellRenderer,
								handlePlanActiveHandleRender: handlePlanActiveHandleRender,
								handleActionButtonRender: handleActionButtonRender,
								handlePlanEndDateCellRenderer: handlePlanEndDateCellRenderer,
								handleFormActionButtonRender: handleFormActionButtonRender,
								handleEditButtonRender: handleEditButtonRender
							}}
						>
							<AgGridColumn
								field="plan_code"
								headerName="Plan Code"
								suppressSizeToFit={true}
							></AgGridColumn>
							<AgGridColumn
								field="plan_name"
								headerName="Plan Name"
								suppressSizeToFit={true}
							></AgGridColumn>
							<AgGridColumn
								field="employee_class"
								headerName="Employee Class"
								cellRenderer="handleEmployeeClassCellRenderer"
							></AgGridColumn>
							<AgGridColumn
								field="start_date"
								headerName="Start Date"
								cellRenderer="handlePlanEndDateCellRenderer"
							></AgGridColumn>
							<AgGridColumn
								cellRenderer="handlePlanEndDateCellRenderer"
								field="end_date"
								headerName="End Date"
							></AgGridColumn>
							<AgGridColumn
								field="status"
								cellRenderer="handlePlanActiveHandleRender"
								headerName="Status"
								filter={false}
								cellRendererParams={{
									queryGroupNumber: queryGroupNumber,
									coreVEBSwitchStatus: coreVEBSwitchStatus
								}}
							></AgGridColumn>
							{tabLabel != "Draft Plans" && (
								<AgGridColumn
									field="action"
									headerName="Action"
									suppressSizeToFit={true}
									cellRenderer="handleActionButtonRender"
									filter={false}
									cellRendererParams={{
										tabLabel,
										anchorEl: anchorEl,
										planDetailsPopOverData: planDetailsPopOverData,
										queryGroupNumber: queryGroupNumber,
										editEndDate: editEndDate
									}}
								></AgGridColumn>
							)}

							{tabLabel === "Draft Plans" && (
								<AgGridColumn
									field="Edit_Action"
									headerName="Edit VEB Plnas"
									suppressSizeToFit={true}
									cellRenderer="handleEditButtonRender"
									filter={false}
									cellRendererParams={{
										tabLabel,
										anchorEl,
										planDetailsPopOverData,
										queryGroupNumber,
										editEndDate
									}}
								/>
							)}

							<AgGridColumn
								field="plan_code"
								headerName="Form Design Action"
								suppressSizeToFit={true}
								// cellRenderer="handleFormActionButtonRender"
								cellRendererFramework={PlanDesignFormCellRenderer}
								// cellRendererParams={{
								// 	anchorEl,
								// 	setAnchorEl
								// }}
								// filter={false}
								// cellRendererParams={{
								// 	anchorEl: anchorEl,
								// 	planDetailsPopOverData: planDetailsPopOverData,
								// 	queryGroupNumber: queryGroupNumber,
								// 	editEndDate: editEndDate
								// }}
							></AgGridColumn>
						</AgGridReact>
					) : null}
				</div>
			</div>
			{/* VEB Plan modal */}
			{editModalType === "VEB" && selectedPlan?._id && (
				<UpdateVEBPlan
					createdPlan={selectedPlan}
					planId={selectedPlan._id}
					onClose={() => setEditModalType(null)}
				/>

				// <EditableBrandingPage plan={selectedPlan} />
			)}
			{editModalType === "BRANDING" && selectedPlan?._id && (
				<EditableBrandingPage plan={selectedPlan} onClose={() => setEditModalType(null)} />
			)}
			{/* Date Picker modal */}
			{editModalType === "DATE" && selectedPlan?._id && (
				<CustomDatePickerDialog
					dialogProps={{
						openDialog: true,
						title: "Edit Plan End Date"
					}}
					handleClose={() => setEditModalType(null)}
					editEndDate={editEndDate}
					setEditEndDate={setEditEndDate}
				/>
			)}
		</>
	);
};

export default PlanManagementGrid;
